import { ControlledList } from 'framework/list';
import { InterruptionEmployeeResponseStatus, InterruptionListCardView } from '../types';
import InterruptionListLayout from './layout/InterruptionListLayout';

type InterruptionListProps = {
  items: InterruptionListCardView[];
  loading: boolean;
  onUpdateStatus: (id: string, status: InterruptionEmployeeResponseStatus) => Promise<boolean>;
};

const InterruptionList = ({ items, loading, onUpdateStatus }: InterruptionListProps) => {
  return (
    <ControlledList data={{ items, totalElements: items.length, totalPages: 1 }} loading={loading}>
      <InterruptionListLayout onUpdateStatus={onUpdateStatus} />
    </ControlledList>
  );
};

export default InterruptionList;
